import { Icon, IconProps } from "@/base/components/icon/Icon.component";
import IconSvg from "./visibility-off.svg?react";

export const VisibilityOffIcon = (props: IconProps) => (
  <Icon component={IconSvg} {...props} />
);
